import { getLocalTimeZone } from "@internationalized/date";

import { format } from "@/lib/utils";

export function getReceiveTimezone(accession: {
  receivingOrg?: { timezone?: string | null } | null;
}): string | null {
  return accession.receivingOrg?.timezone ?? null;
}

export function resolveReceiveTimezoneFromLabId(
  receivingOrgId: number | undefined,
  labs: { id: number; timezone: string | null }[],
  fallbackOrg?: { timezone?: string | null } | null,
): { timezone: string; missingConfiguredTimezone: boolean } {
  const lab = labs.find((item) => item.id === receivingOrgId);
  const configured = lab?.timezone ?? fallbackOrg?.timezone ?? null;

  if (configured) {
    return { timezone: configured, missingConfiguredTimezone: false };
  }

  return {
    timezone: getLocalTimeZone(),
    missingConfiguredTimezone: true,
  };
}

export function formatReceivedAtDisplay(
  receivedAt: Date | string | null | undefined,
  receiveTimezone: string | null,
): {
  formatted: string | null;
  missingConfiguredTimezone: boolean;
} {
  if (!receivedAt) {
    return { formatted: null, missingConfiguredTimezone: false };
  }

  const missingConfiguredTimezone = receiveTimezone == null;
  const zone = receiveTimezone ?? getLocalTimeZone();

  return {
    formatted: format(receivedAt, { showTz: true, zone }),
    missingConfiguredTimezone,
  };
}
